import Chip from '@mui/material/Chip';
import type { ChaveDeSla } from '@anery/design-system';

import { ROTULOS_DE_SITUACAO_DA_RESPOSTA, type SituacaoDaResposta } from './api/tipos';

/**
 * A situação vem do SERVIDOR (`TriagemDeadlineStatusCalculator`); aqui só se escolhe a cor, do mesmo token `sla.*` do
 * `SeloDeSla`. Não reusa o `SeloDeSla`: aquele classifica no front, com o limiar do front.
 */
const CHAVE_DE_COR: Record<SituacaoDaResposta, ChaveDeSla> = {
  None: 'semPrazo',
  OnTrack: 'ok',
  Approaching: 'atencao',
  Overdue: 'estourado',
  AnsweredOnTime: 'ok',
  AnsweredLate: 'estourado',
};

/** O rótulo escrito acompanha a cor: quem não distingue as cores continua lendo o estado. */
export function SeloDaSituacaoDoPrazo({ situacao }: { situacao: SituacaoDaResposta }): React.JSX.Element {
  return (
    <Chip
      size="small"
      label={ROTULOS_DE_SITUACAO_DA_RESPOSTA[situacao]}
      sx={(tema) => {
        const tom = tema.palette.sla[CHAVE_DE_COR[situacao]];
        return {
          backgroundColor: tom.fundo,
          color: tom.tinta,
          border: `1px solid ${tom.borda}`,
          fontWeight: 600,
          height: 20,
        };
      }}
    />
  );
}
